/** @module Enums */ /** typedoc */

export enum TrackTypeEnum {
    Audio = 'Audio',
    Stem = 'STEM',
    Video = 'Video',
    Album = 'Album',
    VideoTrack = 'VideoTrack'
}
